import { useEffect, useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { Check } from "lucide-react";
import { useSiteContent } from "@/hooks/useSiteContent";
import { DEFAULTS } from "@/lib/content_defaults";

export default function Pricing() {
  const [packages, setPackages] = useState([]);
  const [loading, setLoading] = useState({});
  const { data: hero } = useSiteContent("page_hero_pricing", DEFAULTS.page_hero_pricing);

  useEffect(() => { api.get("/memberships").then(r => setPackages(r.data)); }, []);

  const start = async (pkg) => {
    setLoading({ ...loading, [pkg.key]: true });
    try {
      const origin = window.location.origin;
      const { data } = await api.post("/checkout/session", { kind: "membership", item_id: pkg.key, origin_url: origin });
      window.location.href = data.url;
    } catch { toast.error("Could not start checkout."); setLoading({ ...loading, [pkg.key]: false }); }
  };

  return (
    <div>
      <section className="section-dark py-20">
        <div className="container-app">
          <div className="label-tag mb-4">{hero.label_tag}</div>
          <h1 className="font-heading font-black uppercase text-5xl md:text-7xl leading-none">
            {hero.line1}<br/><span className="metallic-gold">{hero.line2}</span>{hero.line3 && <><br/><span className="metallic-silver">{hero.line3}</span></>}
          </h1>
          <p className="mt-6 text-white/70 max-w-2xl text-lg">{hero.subtitle}</p>
        </div>
      </section>
      <section className="section-light py-20">
        <div className="container-app grid md:grid-cols-2 lg:grid-cols-3 gap-4" data-testid="pricing-grid">
          {packages.map((p) => (
            <div key={p.key} className={`card-light p-8 hover-lift flex flex-col ${p.featured ? "lg:border-2 lg:border-[color:var(--gold)]" : ""}`} data-testid={`plan-${p.key}`}>
              {p.featured && <div className="label-tag mb-2" style={{ color: "#D4AF37" }}>Most Popular</div>}
              <div className="font-heading font-black uppercase text-2xl">{p.name}</div>
              <div className="mt-4 font-heading font-black text-6xl">${p.price.toFixed(0)}<span className="text-lg text-neutral-500 font-normal">/{p.billing === "monthly" ? "mo" : "once"}</span></div>
              <ul className="mt-8 space-y-3 text-sm text-neutral-700 flex-1">
                {p.features.map((f,idx) => (
                  <li key={idx} className="flex gap-2 items-start"><Check size={16} className="text-[color:var(--gold)] mt-0.5 flex-shrink-0"/>{f}</li>
                ))}
              </ul>
              <button onClick={() => start(p)} disabled={loading[p.key]} className="btn-gold mt-8 justify-center" data-testid={`plan-cta-${p.key}`}>{loading[p.key] ? "…" : "Get Started"}</button>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
